import { BooleanLiteral } from "typescript";
import MessageContainer from "./components/common/MessageContainer";

interface ILoadingComponent {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  ComponentBody: any;
}

const LoadingComponent = ({
  isLoading,
  isSuccess,
  isError,
  ComponentBody,
}: ILoadingComponent) => {
  if (isLoading) {
    return <MessageContainer message={"Loading"} />;
  }

  if (!isSuccess && isError) {
    return <MessageContainer message={"Something went wrong"} />;
  }

  return ComponentBody;
};

export default LoadingComponent;
